/**
 *
 * Asynchronously loads the component for Video
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Unsubscribe/Loadable.js